var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "cvv-info" } }, [
      _c("div", [
        _vm._v(
          " The CVV number is a 3- or 4-digit security code, usually located on the back of your card. "
        ),
      ]),
      _c("br"),
      _c("img", {
        attrs: {
          id: "credit-card-back",
          src: require("@/assets/images/back-of-credit-card.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }